// 자동 퀘스트 공유 상태: UI(src/ui/autoQuest.ts)가 쓰고, 렌더(바닥 점선·목적지 표식)와 퀘스트 카드·HUD 버튼이 읽는다.
// 시뮬레이션은 이 파일을 쓰지 않는다. 배열은 한 번만 만든다.
import { NAV_MAX_POINTS } from './nav';

export type AutoIcon = '' | 'forge' | 'shop' | 'trainer' | 'gate' | 'room';

export const autoRoute = {
  /** 점선을 그릴지(걷는 중일 때만) */
  active: false,
  /** 경로·목적지가 바뀔 때마다 1 증가 */
  version: 0,
  count: 0,
  /** 남은 꺾는 점(지금 향하는 점부터) */
  xs: new Float32Array(NAV_MAX_POINTS),
  zs: new Float32Array(NAV_MAX_POINTS),
  /** 목적지 표식 위치와 그림. icon ''이면 표식 없음 */
  icon: '' as AutoIcon,
  tx: 0,
  tz: 0,
};

/** 지금 진행 중인 자동 목표 키(퀘스트 카드·HUD 버튼 강조용). 'npc:forge' · 'door:r1' · 'dungeon' · '' */
export const autoActive = { key: '' };

